import { editedEntityStore, uiStore, userStore } from "@/mobx/rootStore";
import { routesList } from "@/routesList";

export async function repair() {
	userStore.reset();
	uiStore.reset();
	editedEntityStore.reset();

	localStorage.clear();

	window.location.href = routesList.login.path;
}
